import { Spin } from 'antd';
import { FC, memo } from 'react';

import './Spinner.scss';

export const Spinner: FC = memo(() => {
  return (
    <div className="spinner-container">
      <Spin size="large"/>
    </div>
  );
});
